import { useEffect, useMemo, useRef, useState } from 'react'
import ReportsPagesContent from 'src/component/ReportsPagesContent'
import { GetApprovalRequest } from 'src/requests/DoctorRequest'
import SearchWrapper from 'src/component/searchSection'
import { Original } from 'src/common/Common.Type'
import { errorToaster, handleDate } from 'src/utils'
// import usePrint from 'src/hooks/usePrint'
import { useTranslation } from 'react-i18next'
import { useGet } from 'src/hooks/useGet'
import { GetRequestForPrint } from 'src/requests/Shared'
import { RowAction } from 'src/component/RequestRowAction/inde'
import PrintContentWrapper from 'src/component/PrintContentWrapper/PrintContentWrapper'
import PrintableRequestTable from 'src/component/PrintedPDF/PrintRequestTable/PrintableRequestTable'
import MedicinesPopup from './MedicinesPopup'
import { useLocation } from 'react-router-dom'

const OrderReview = () => {

  const { t } = useTranslation()

  const [recordID, setRecordID] = useState<number | null>(null)
  const [hospitalID, setHospitalID] = useState<number | null>(null)
  const [selectedPrintRequestId, setSelectedPrintRequestId] = useState<number | null>(null)
  const [isModel56, setIsModel56] = useState<boolean | null>(null)

  // const { handlePrint, printRef } = usePrint({ validation: false, title: t("billRequest") || "" })

  const { data: requestRow } = useGet({ API: GetRequestForPrint, depArr: [selectedPrintRequestId], isNotValid: !selectedPrintRequestId, params: [selectedPrintRequestId], defaultValue: null })

  const modelpopup = useRef<any>("")


  const columns = useMemo(() => [
    {
      Header: "requestId",
      accessor: "id",
      Cell: ({ row }: any) => RowAction(row, (ObjectData: any) => ShowAccordion(ObjectData.id, ObjectData.hospitalId), handlePrintModel)
    },
    {
      Header: "patientName",
      accessor: "patientName",
      canSearch: true
    },
    {
      Header: "phoneNumber",
      accessor: "phoneNumber",
    },
    {
      Header: "nationalId",
      accessor: "patientNationalId",
    },
    {
      Header: "hospitalName",
      accessor: "hospitalName",
    },
    {
      Header: "diagnosis",
      accessor: "diagnosis",
    },
    {
      Header: "status",
      accessor: "status",
    },
    {
      Header: "serviceType",
      accessor: "serviceType",
    },
    {
      Header: "requestDueDate",
      accessor: "requestDueDate",
      Cell: ({ row: { original } }: Original) => <> {handleDate(original?.requestDueDate)}</>
    },
    {
      Header: "requestCreatedDate",
      accessor: "requestCreatedDate",
      canSearch: true,
      visible: false,
      type: "Date",
      isMulti: true,
    },
  ], [selectedPrintRequestId])


  // useEffect(() => {
  //   if (!(printRef.current && requestRow && selectedPrintRequestId)) return
  //   handlePrint();
  //   setSelectedPrintRequestId(null);

  // }, [handlePrint, requestRow, selectedPrintRequestId]);


  const ShowAccordion = (id: number, hopsitalId: number) => {
    // if (!!!sessionStorage.getItem("optionId")) return errorToaster("please-select-hosptial")
    modelpopup.current.click()
    setRecordID(id)
    setHospitalID(hopsitalId)
  }
  const handlePrintModel = (id: number, isModel: boolean) => {
    setIsModel56(isModel)
    setSelectedPrintRequestId(id)
  }

  return (

    <>
      {/* <PrintContentWrapper printRef={printRef} >
        <PrintableRequestTable  data={requestRow} recordId={selectedPrintRequestId} />
      </PrintContentWrapper> */}

      <MedicinesPopup isAllowModel56={isModel56} hospitalId={hospitalID} recordID={recordID} modalID={modelpopup} />

      <ReportsPagesContent tableAPI={GetApprovalRequest} columns={columns} >
        <SearchWrapper></SearchWrapper>
      </ReportsPagesContent>
    </>
  )
}

export default OrderReview